<div class="container">
  <span class="title">{{title}}</span>
  <div class="inner">
    <ng-container *ngIf="startIcon">
      <ng-component [ngComponentOutlet]="startIcon"></ng-component>
    </ng-container>
    <input type="text" [placeholder]="placeholder || ('Common.Input.placeholder' | translate)" [ngModel]="value"
      (ngModelChange)="onInputChange($event)" [class]="className" [name]="name" [disabled]="disabled" class="input" />
  </div>
</div>